import { Component, Input } from '@angular/core';

import { Step } from './steps.interface';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
  standalone: false,
})
export class StepsComponent {
  @Input() steps: Step[];
  @Input() isMobile = false;
  @Input() selectedIndex: number;

  /**
   * Add Track By Steps to not redraw or
   * re-render list items that have not changed. This improves performance.
   * @param index - Index of Step array
   * @param step - Step item
   * @returns step name
   */
  trackBySteps(index: number, step: Step): string {
    if (step) {
      return step.name;
    } else {
      return String(index);
    }
  }
}
